import React from 'react'
import PropTypes from 'prop-types'
import { DISPLAY } from 'constants/display'

export const ItemList = ({ listItems }) => (
  <>
    {listItems.map(item => (
      <div key={item.label} className='flex justify-between'>
        <p className='di'>{item.label}</p>
        <p className={`di ${item.textClass || 'text-secondary'}`}>{item.value || DISPLAY.empty}</p>
      </div>
    ))}
  </>
)

ItemList.propTypes = {
  listItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      class: PropTypes.string,
    })
  ),
}

ItemList.defaultProps = { listItems: [] }

export default ItemList
